import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AUTH_DETAILS, AUTH_TOKEN, MENU_ITEMS } from 'constants/AuthConstant';
import { useDispatch } from 'react-redux';
import masterService from 'services/MasterService';



export const initialState = {
    loading: false,
    message: '',
    list: null,
    sublist: null,
    subloading: false
}

export const discountListAll = createAsyncThunk('/discountauthoritie/list', async (data, { rejectWithValue }) => {

    try {
        const response = await masterService.getDiscount(data)
        return response.data;
    } catch (err) {
        return rejectWithValue(err.response?.data?.message || 'Error')
    }
})

export const discountSubListAll = createAsyncThunk('/discountauthoritie/subList', async (data, { rejectWithValue }) => {

    try {
        const response = await masterService.getDiscount(data)
        return response.data;
    } catch (err) {
        return rejectWithValue(err.response?.data?.message || 'Error')
    }
})




export const discountSlice = createSlice({
    name: 'discount',
    initialState,
    reducers: {

        discountList: (state, action) => {
            state.loading = true
            state.list = action.payload
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(discountListAll.pending, (state) => {

                state.loading = false
            })
            .addCase(discountListAll.fulfilled, (state, action) => {
                state.loading = true
                state.list = action.payload
            })
            .addCase(discountSubListAll.pending, (state) => {

                state.subloading = false
            })
            .addCase(discountSubListAll.fulfilled, (state, action) => {
                state.subloading = true
                state.sublist = action.payload
            })
    },
})

export const {
    discountList


} = discountSlice.actions

export default discountSlice.reducer